<template>
  <div class="addFamily">
    <info-form @submit-form="addFamily" isFamily></info-form>
  </div>
</template>

<script>
import { addFamily } from "@/api/user.js";

export default {
  name: "addFamily",
  methods: {
    async addFamily(form) {
      form.loading.load = true;
      const { code } = await addFamily(form);
      form.loading.load = false;
      if (code === 0) {
        this.$toast({
          message: "保存成功",
          icon: require("@/assets/images/success.png")
        });
        this.$router.go(-1);
      } else if (code === 1) {
        this.$toast({
          message: "添加失败,请先完善个人信息",
          icon: require("@/assets/images/success.png")
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
